import { FlexColumn } from "../../../../../Common/Styles";
import { AudioContent } from "./AudioContent";
import { GIFContent } from "./GIFContent";
import { ImageContent } from "./ImageContent";
import { PostPollContent } from "./PostPollContent";
import { PostRateContent } from "./PostRateContent";
import { RepostContent } from "./RepostContent";
import { TextContent } from "./TextContent";
import { VideoContent } from "./VideoContent";

export const DefaultContentLayout = () => {
  return (
    <FlexColumn $gapInPx={0}>
      <TextContent />
      <ImageContent />
      <PostPollContent />
      <PostRateContent />
      <RepostContent />
      <VideoContent />
      <AudioContent />
      <GIFContent />
    </FlexColumn>
  );
};
